import { createInstance } from 'i18next';

import { logException } from '#/features/logging/logging';

import { supportedLocales, resources } from './translations';

// docs: https://www.i18next.com/overview/typescript
declare module 'i18next' {
  interface CustomTypeOptions {
    resources: typeof resources.en;
  }
}

const i18nInstance = createInstance({
  debug: ENVIRONMENT === 'development',
  resources,
  supportedLngs: supportedLocales,
  lng: 'en', // WIP: recover last chosen locale from localStorage, fallback to 'en' if not found
  fallbackLng: false, // We use approach similar to `GNU gettext` where missing keys are written in plain English and just used as fallback
  interpolation: {
    escapeValue: false, // Escaping(XSS prevention) is handled by React
  },
  saveMissing: true, // Required for `missingKey` handler to be called
} as const);
i18nInstance.init().catch((cause: unknown) => {
  const message = 'Unknown error initializing i18next';
  const error = new Error(message, { cause });
  logException(error);
});
i18nInstance.on('missingKey', (lngs, namespace, key) => {
  const message = 'Missing key in i18next';
  const error = new Error(message);
  logException(error, { lngs, namespace, key });
});

export type { Locale } from './translations';
export { supportedLocales } from './translations';
export { I18nextProvider } from 'react-i18next';
export { i18nInstance };
